function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "icon-device--phone_svg__a",
  x1: 9.77,
  y1: 22.23,
  x2: 30.05,
  y2: 1.95,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#646a70"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#bcc4c9"
})), React.createElement("linearGradient", {
  id: "icon-device--phone_svg__b",
  x1: 14.1,
  y1: 30.85,
  x2: 16.78,
  y2: 28.16,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#bcc4c9"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#e2e6e9"
})), React.createElement("linearGradient", {
  id: "icon-device--phone_svg__c",
  x1: 13.78,
  y1: 27.12,
  x2: 25.97,
  y2: 14.93,
  xlinkHref: "#icon-device--phone_svg__b"
}), React.createElement("linearGradient", {
  id: "icon-device--phone_svg__d",
  x1: -3.99,
  y1: 27.09,
  x2: 13.11,
  y2: 10,
  xlinkHref: "#icon-device--phone_svg__b"
}), React.createElement("g", {
  id: "icon-device--phone_svg__e"
}, React.createElement("rect", {
  x: 8.06,
  y: 1.05,
  width: 15.89,
  height: 29.89,
  rx: 1.64,
  ry: 1.64,
  fill: "url(#icon-device--phone_svg__a)"
}), React.createElement("circle", {
  cx: 16,
  cy: 28.94,
  r: 1,
  fill: "url(#icon-device--phone_svg__b)"
}), React.createElement("path", {
  d: "M9.06 22.94v3.8a.25.25 0 00.25.25h13.38a.25.25 0 00.25-.25V9.06z",
  fill: "url(#icon-device--phone_svg__c)"
}), React.createElement("path", {
  d: "M22.94 5.25a.25.25 0 00-.25-.25H9.31a.25.25 0 00-.25.25v17.69L22.94 9.06z",
  fill: "url(#icon-device--phone_svg__d)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#icon-device--phone_svg__e"
});

var SvgIconDevicePhone = function SvgIconDevicePhone(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-device--phone.550cea52.svg";
export { SvgIconDevicePhone as ReactComponent };